import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Intro from "./components/Intro";
import Meaning from "./components/Meaning";
import Origin from "./components/Origin";
import Usage from "./components/Usage";
import Glossary from "./components/Glossary";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <Meaning />
        <Origin />
        <Usage />
        <Glossary />
        <Faq />
        <About />
      </main>
      <Footer />
    </>
  );
}